import ActionTypes from "actions/ActionTypes";
import api from "api";
import { ActionCreator, Dispatch } from "redux";

export const getStoreStatistic: ActionCreator<any> =
  () => async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.STORE_STATISTIC_REQUEST });
    try {
      const res = await api.getStoreStatistic();
      if (res?.result) {
        dispatch({
          type: ActionTypes.STORE_STATISTIC_SUCCESS,
          payload: { data: res?.result },
        });
      } else {
        dispatch({ type: ActionTypes.STORE_STATISTIC_SUCCESS });
      }
    } catch (e) {
      dispatch({ type: ActionTypes.STORE_STATISTIC_SUCCESS });
    }
  };
